<template>
  <v-dialog width="520" v-model="internalDialog" scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>CẬP NHẬT TRẠNG THÁI CÔNG VIỆC</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text class="py-4">
        <v-row>
          <v-subheader>Trạng thái công việc hiện tại</v-subheader>
          <v-col cols="12" class="d-flex align-center">
            <v-chip :color="statusColor(currentStatus)" text-color="white" class="mr-2">
              {{ statusText(currentStatus) }}
            </v-chip>
            <v-icon large>mdi-arrow-right</v-icon>
            <v-select
              class="required"
              v-model="newStatus"
              :items="statusOptionsForUser"
              item-text="text"
              item-value="value"
              dense
              placeholder="Trạng thái công việc mới"
              outlined
              hide-details
              style="margin-left: 8px; max-width: 200px"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-none text-uppercase" outlined @click="cancel">Huỷ</v-btn>
        <v-btn color="primary text-none text-uppercase" elevation="0" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    dialog: Boolean,
    task: Object,
  },
  data() {
    return {
      newStatus: '',
      currentStatus: '',
      internalDialog: false,
      statusOptions: [
        { text: 'Chưa bắt đầu', value: 'not_started', color: 'grey' },
        { text: 'Đang thực hiện', value: 'in_progress', color: 'orange' },
        { text: 'Hoàn thành', value: 'completed', color: 'green' },
        { text: 'Chờ đánh giá', value: 'waiting', color: 'red' },
      ],
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    statusOptionsForUser() {
      const status = this.task.status
      const isReceiver = this.isReceiver()
      const isCreator = this.isCreator()
      if (isCreator && status === 'waiting') {
        return this.statusOptions.filter(s => ['completed', 'in_progress'].includes(s.value))
      }
      if (isReceiver) {
        if (status === 'not_started') {
          return this.statusOptions.filter(s => ['in_progress', 'waiting'].includes(s.value))
        }
        if (status === 'in_progress') {
          return this.statusOptions.filter(s => s.value === 'waiting')
        }
      }
      return []
    },
  },
  methods: {
    cancel() {
      this.internalDialog = false
      this.$emit('close')
    },
    async save() {
      if (!this.newStatus || this.newStatus === this.task.status) return
      try {
        const payload = {
          status: this.newStatus,
          id: this.task._id,
          currentStatus: this.task.status,
        }
        const res = await this.$store.dispatch('tasknew/updateTask', payload)
        if (res) {
          this.task.status = this.newStatus
          this.newStatus = ''
          this.$alert.success('Cập nhật trạng thái thành công!')
          this.$emit('updated')
          this.cancel()
        } else {
          this.$alert.error('Cập nhật trạng thái thất bại')
        }
      } catch (err) {
        console.error(err)
        this.$alert.error('Có lỗi xảy ra')
      }
    },
    initData() {
      if (!this.task) return
      this.currentStatus = this.task.status
      this.newStatus = ''
    },
    isCreator() {
      if (!this.task || !this.user) return false
      return this.task.creatorData.user_id == this.user.id
    },
    isReceiver() {
      if (!this.task || !this.user) return false
      return (this.task.receiversData || []).some(r => r.user_id == this.user.id)
    },
    statusText(status) {
      const map = {
        not_started: 'Chưa bắt đầu',
        in_progress: 'Đang thực hiện',
        completed: 'Hoàn thành',
        waiting: 'Chờ đánh giá',
      }
      return map[status] || '-'
    },
    statusColor(status) {
      const map = {
        not_started: 'grey',
        in_progress: 'orange',
        completed: 'green',
        waiting: 'red',
      }
      return map[status] || 'grey'
    },
  },

  watch: {
    dialog(val) {
      this.internalDialog = val
      if (val) this.initData()
    },
  },
}
</script>
